module.exports = __webpack_public_path__ + "static/media/silver-member.81e3e700.png";